/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 5d3d2bc2 (Tue Dec 30 16:20:46 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The default start dates for new programs created in this region. This supports adding new programs alongside creating a new community.
 * @export
 * @interface CommunityOptionsDefaultProgramStartDates
 */
export interface CommunityOptionsDefaultProgramStartDates {
  /**
   *
   * @type Date
   * @memberof CommunityOptionsDefaultProgramStartDates
   */
  semesterOneStartDate: Date
  /**
   *
   * @type Date
   * @memberof CommunityOptionsDefaultProgramStartDates
   */
  semesterTwoStartDate: Date
}

export function CommunityOptionsDefaultProgramStartDatesFromJSON(
  json: any
): CommunityOptionsDefaultProgramStartDates {
  return CommunityOptionsDefaultProgramStartDatesFromJSONTyped(json, false)
}

export function CommunityOptionsDefaultProgramStartDatesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CommunityOptionsDefaultProgramStartDates {
  if (json === undefined || json === null) {
    return json
  }
  return {
    semesterOneStartDate: new Date(json['semesterOneStartDate']),
    semesterTwoStartDate: new Date(json['semesterTwoStartDate']),
  }
}

export function CommunityOptionsDefaultProgramStartDatesToJSON(
  value?: CommunityOptionsDefaultProgramStartDates | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    semesterOneStartDate: value.semesterOneStartDate
      .toISOString()
      .substr(0, 10),
    semesterTwoStartDate: value.semesterTwoStartDate
      .toISOString()
      .substr(0, 10),
  }
}
